import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import { AddButton } from 'components/atoms/button';
import { Link } from 'components/atoms/link';
import { RoutePaths, PermissionRuleName } from 'constant';

export const ProjectCreateButton = () => {
  const { search, hash } = useLocation();

  return (
    <Link
      to={{ pathname: RoutePaths.projectCreate, search, hash }}
      data-cy="buttons.new-project"
      ruleName={PermissionRuleName.ProjectCreateAction}
    >
      <AddButton size="small">
        <FormattedMessage id="projects.create.title" />
      </AddButton>
    </Link>
  );
};
